import ReceiptTextWithBadgeClockSvg from '@assets/images/svg/receipt-text-with-badge-clock.svg';
import React from 'react';
import { View } from 'react-native';

export interface ReceiptTextWithBadgeClockIconProps {
    size?: number;
    clockBadgeColor?: string;
}

export function ReceiptTextWithBadgeClockIcon({ size = 80, clockBadgeColor = '#FAC12D' }: ReceiptTextWithBadgeClockIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <ReceiptTextWithBadgeClockSvg width={size} height={size} color={clockBadgeColor} />
        </View>
    );
}

export default ReceiptTextWithBadgeClockIcon;
